import { api } from '../../lib/api.ts';

export type SubStatus = 'NOT_SET' | 'ACTIVE' | 'GRACE' | 'BLOCKED';
export interface SubRow {
  id: string; name: string; contactEmail: string;
  paidUntil: string | null; subscriptionNote: string | null;
  status: SubStatus; daysLeft: number | null;
}

export const subscriptionsApi = {
  list: () => api.get<{ subscriptions: SubRow[] }>('/admin/subscriptions').then((r) => r.data.subscriptions),
  setDate: (id: string, paidUntil: string | null, note?: string) =>
    api.patch(`/admin/organizations/${id}/subscription`, { paidUntil, note }).then((r) => r.data),
  getBanner: () => api.get<{ value: string }>('/admin/subscriptions/banner').then((r) => r.data.value),
  setBanner: (value: string) => api.put<{ value: string }>('/admin/subscriptions/banner', { value }).then((r) => r.data.value),
  myStatus: () => api.get<{ status: SubStatus; renewBy: string | null; banner: string | null }>('/subscription/status').then((r) => r.data),
};
